import type { ReactNode } from "react"
import { usePage } from "@inertiajs/react"
import { mocked } from "storybook/test"

type StorybookPageProps = Record<string, unknown>

type MockPageOptions = {
  url?: string
  props?: StorybookPageProps
}

export const sampleUser = {
  name: "Mariana López",
  email: "mariana@menny.app",
  initials: "ML",
  avatar: null,
}

export const sampleCurrentLocation = {
  id: 42,
  name: "Menny Roma Norte",
}

export const sampleAvailableLocations = [
  sampleCurrentLocation,
  { id: 43, name: "Menny Condesa" },
  { id: 44, name: "Menny Juárez" },
]

export function mockPage({ url = "/", props = {} }: MockPageOptions = {}) {
  mocked(usePage).mockReturnValue({
    component: "Storybook",
    props,
    url,
    version: null,
    clearHistory: false,
    encryptHistory: false,
  } as unknown as ReturnType<typeof usePage>)
}

export function LayoutPreviewContent({
  title,
  eyebrow,
  children,
}: {
  title: string
  eyebrow: string
  children?: ReactNode
}) {
  return (
    <main className="p-6">
      <section className="rounded-2xl border bg-card p-6 shadow-sm">
        <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
          {eyebrow}
        </p>
        <h1 className="mt-2 text-2xl font-bold tracking-tight">{title}</h1>
        <p className="mt-2 max-w-2xl text-sm text-muted-foreground">
          Esta tarjeta representa el contenido que Inertia renderiza dentro del layout.
        </p>
        {children ? <div className="mt-6">{children}</div> : null}
      </section>
    </main>
  )
}

